import { useLocation } from 'react-router-dom'
import { useRef, useEffect, useState } from 'react'
import HelixSearch from '../../pages/HelixSearch'

export default function HelixSearchPageWrapper() {
    const location = useLocation()
    const hadQueryParamsRef = useRef<boolean>(location.search !== '')
    const hasRemountedRef = useRef<boolean>(false)
    const [key, setKey] = useState('stable')

    useEffect(() => {
        if (!hadQueryParamsRef.current && location.search !== '') {
            hadQueryParamsRef.current = true
        }

        const shouldRemount =
            hadQueryParamsRef.current && location.search === ''

        if (shouldRemount && !hasRemountedRef.current) {
            // console.log('[Wrapper] Forcing remount due to param removal')
            setKey(`remount-${Date.now()}`)
            hasRemountedRef.current = true
        }

        if (location.search !== '') {
            hasRemountedRef.current = false // reset so future clears can trigger again
        }

        // console.log('[Wrapper] location.search =', location.search)
        // console.log('[Wrapper] hadQueryParamsRef =', hadQueryParamsRef.current)
        // console.log('[Wrapper] using key =', key)
    }, [location.search]) // DO NOT include `key`

    return <HelixSearch key={key} />
}
